import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import UnknownTemplate from '../../render_components/__template_components/unknown_template';
import PublicationPageV2 from '../../render_components/__template_components/publication_page_v2';
import ArticlePage from '../../render_components/__template_components/article_list/article_page';
import ItemPageV1 from '../../render_components/__template_components/item_page_v1';
import ItemPage from '../../render_components/__template_components/item/item_page';
import CartV1 from '../../render_components/__template_components/cart_v1';
import Cart from '../../render_components/__template_components/cart';

const PublicationPage = () => {
  const currentPublication = useSelector((state) => state.currentPublication.currentPublication);
  const contentData = currentPublication?.content ? JSON.parse(currentPublication.content) : null;
  const templateName = currentPublication?.template?.template_name || null;

  React.useEffect(() => {
    if (!currentPublication) return;
    const name = currentPublication?.template?.template_name ?? '(нет шаблона)';
    // console.log('[PublicationPage]', name, {
    //   show_name: currentPublication?.show_name,
    //   eng_name: currentPublication?.eng_name,
    // });
  }, [currentPublication]);

  // Создаем path_to_folder
  const path_to_folder = currentPublication
    ? 'https://' + currentPublication.path + currentPublication.eng_name + '/'
    : null;

  const renderTemplate = () => {
    // console.log('PublicationPage template_name:', templateName);
    switch (templateName) {
      case 'Publication_1':
        return <PublicationPageV2 contentData={contentData} path_to_folder={path_to_folder} />;
      case 'publication_v2':
        return <PublicationPageV2 contentData={contentData} path_to_folder={path_to_folder} />;
      case 'article_list':
        return <ArticlePage contentData={contentData} path_to_folder={path_to_folder} />;
      case 'item_data_v1':
        return <ItemPageV1 contentData={contentData} path_to_folder={path_to_folder} />;
      case 'item':
        return <ItemPage contentData={contentData} path_to_folder={path_to_folder} />;
      case 'cart_v1':
        return <CartV1 publication={currentPublication} />;
      case 'cart':
        return <Cart publication={currentPublication} />;
      default:
        return <UnknownTemplate contentData={contentData} path_to_folder={path_to_folder} />;
    }
  };

  const templateContent = renderTemplate();

  // Если нет контента, не рендерим контейнер
  if (!templateContent) {
    return null;
  }

  return <div className={styles.publicationPage}>{templateContent}</div>;
};

export default PublicationPage;
